import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const CLOUDFLARE_FAVICON =
  "https://www.google.com/s2/favicons?domain=cloudflare.com&sz=32";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatUrlForDisplay(url: string): string {
  return url.replace(/^https?:\/\//i, "").replace(/^www\./i, "");
}

export function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
